import styled from 'styled-components';
import { InputText } from '../../inputs';

export const ValueWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const ValueDisplay = styled(InputText)`
  flex: 1;
  border: none;
`;
